import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractModal, ModalButtonModel, ModalButtonType } from '@cv-invision/core';
import { ClipboardService } from 'ngx-clipboard';

@Component({
	selector: 'cv-invision-request-information-log',
	templateUrl: './request-information-log.component.html',
	styleUrls: ['./request-information-log.component.scss']
})
export class RequestInformationLogComponent extends AbstractModal implements OnInit {
	@ViewChild('markupEditor', { static: false }) markupEditor;
	@ViewChild('markupEditor1', { static: false }) markupEditor1;
	@ViewChild('markupEditor2', { static: false }) markupEditor2;
	@ViewChild('markupEditor3', { static: false }) markupEditor3;
	messageInformation: any;
	requestInformation: any;
	responseInformation: any;
	errorInformation: any;
	copyMessage: Array<ModalButtonModel>;
	copyRequest: Array<ModalButtonModel>;
	copyResponse: Array<ModalButtonModel>;
	copyError: Array<ModalButtonModel>;

	constructor(private clipboarService: ClipboardService) {
		super();
	}

	ngOnInit(): void {
		this.copyMessage = [];
		const msgButton: ModalButtonModel = {
			class: 'copy-button',
			icon: 'fad fa-copy',
			type: ModalButtonType.ACTION,
			action: () => this.onCopycode(this.messageInformation)
		};
		this.copyMessage.push(msgButton);

		this.copyResponse = [];
		const responseButton: ModalButtonModel = {
			class: 'copy-button',
			icon: 'fad fa-copy',
			type: ModalButtonType.ACTION,
			action: () => this.onCopycode(this.responseInformation)
		};
		this.copyResponse.push(responseButton);

		this.copyRequest = [];
		const requestButton: ModalButtonModel = {
			class: 'copy-button',
			icon: 'fad fa-copy',
			type: ModalButtonType.ACTION,
			action: () => this.onCopycode(this.requestInformation)
		};
		this.copyRequest.push(requestButton);

		this.copyError = [];
		const errorButton: ModalButtonModel = {
			class: 'copy-button',
			icon: 'fad fa-copy',
			type: ModalButtonType.ACTION,
			action: () => this.onCopycode(this.errorInformation)
		};
		this.copyError.push(errorButton);

		const cancelButton: ModalButtonModel = {
			name: 'close',
			text: 'Close',
			class: 'btn-sm',
			type: ModalButtonType.ACTION,
			action: this.onDismiss.bind(this)
		};
		this.buttons.push(cancelButton);

		const { request, response, messageRequest, errorMessage } = this.data.reuqest;

		// parse json data
		this.requestInformation = this.parseJsonData(request);
		this.responseInformation = this.parseJsonData(response);
		this.messageInformation = this.parseJsonData(messageRequest);
		this.errorInformation = this.parseJsonData(errorMessage);

		setTimeout(() => {
			this.markupEditor.init();
			this.markupEditor1.init();
			this.markupEditor2.init();
			this.markupEditor3.init();
		}, 100);
	}

	/**
	 * parse josn strin from the server
	 * @param info
	 */
	parseJsonData(info: string): string {
		try {
			return JSON.stringify(JSON.parse(info), null, 3);
		} catch (e) {
			return JSON.parse(JSON.stringify(info, null, 1));
		}
	}

	/***
	 * copy response code
	 */
	onCopycode(source: string): void {
		this.clipboarService.copy(source);
	}

	onDismiss(): void {
		super.onCancel();
	}
}
